import { IBannerStretch } from '../../../repositories/developer-card/entities/developer_special_promo/BannerStretch';
import { IApplicationState } from '../../../types/redux';
import { getTemplateSpecialPromo } from './getTemplateSpecialPromo';

export function getTemplateSpecialPromoBannerStretch(state: IApplicationState): IBannerStretch | undefined {
  return getTemplateSpecialPromo(state)?.bannerStretch ?? undefined;
}
